module.exports = {
  white: '#fff',
  black: '#000',
  inherit: 'inherit',
  transparent: 'transparent',
  current: 'currentColor',
  finviz: {
    'blue-gray': '#262931',
    blue: '#4fa4f4',
  },
  gray: {
    50: '#f3f3f5',
    100: '#dedfe5',
    200: '#c3c6d0',
    300: '#a3a8b9',
    400: '#868ea5',
    500: '#676f85',
    600: '#4c5263',
    700: '#353945',
    750: '#2c303b',
    800: '#22262f',
    900: '#13151c',
  },
  red: {
    50: '#fef0f0',
    100: '#fcd6d6',
    200: '#fbb4b4',
    300: '#fd8487',
    400: '#fb5058',
    500: '#d9222e',
    600: '#a21826',
    700: '#730f19',
    800: '#50070f',
    900: '#330307',
  },
  orange: {
    50: '#fef2eb',
    100: '#fdd9c5',
    200: '#fab889',
    300: '#ef9323',
    400: '#ca7b14',
    500: '#a0600e',
    600: '#79460a',
    700: '#583006',
    800: '#3d1e03',
    900: '#261101',
  },
  amber: {
    50: '#fef2e7',
    100: '#fedab5',
    200: '#fbba56',
    300: '#de9c1a',
    400: '#bb830f',
    500: '#956600',
    600: '#704b00',
    700: '#4f3400',
    800: '#372200',
    900: '#211300',
  },
  yellow: {
    50: '#fdf3df',
    100: '#fcdd93',
    200: '#f3c727',
    300: '#cea30c',
    400: '#af8800',
    500: '#8c6a00',
    600: '#6a4f05',
    700: '#493606',
    800: '#322403',
    900: '#1e1400',
  },
  lime: {
    50: '#ebfad6',
    100: '#caec90',
    200: '#aad547',
    300: '#8db61e',
    400: '#769913',
    500: '#5b7800',
    600: '#435900',
    700: '#2e3e00',
    800: '#1e2a00',
    900: '#111900',
  },
  green: {
    50: '#e7f7e8',
    100: '#beeac1',
    200: '#86d895',
    300: '#34c062',
    400: '#00a449',
    500: '#008138',
    600: '#006028',
    700: '#00431a',
    800: '#002d0e',
    900: '#001a06',
  },
  emerald: {
    50: '#ddfaee',
    100: '#a2f0d2',
    200: '#4dddaf',
    300: '#25be93',
    400: '#1d9f7b',
    500: '#157e60',
    600: '#035d47',
    700: '#004139',
    800: '#002c22',
    900: '#001a13',
  },
  teal: {
    50: '#e0f8fc',
    100: '#9beef7',
    200: '#4fd8e5',
    300: '#27b9c4',
    400: '#109ba5',
    500: '#007c83',
    600: '#005b62',
    700: '#004045',
    800: '#002b2e',
    900: '#00191b',
  },
  blue: {
    50: '#ecf4fe',
    100: '#cae2fd',
    200: '#9dcafc',
    300: '#58aefb',
    400: '#2091f4',
    500: '#146ed0',
    600: '#1050a3',
    700: '#09357d',
    800: '#03235a',
    900: '#021339',
  },
  violet: {
    50: '#f5f3fe',
    100: '#e2dcfd',
    200: '#c9befc',
    300: '#ad9bfb',
    400: '#9578f9',
    500: '#7f48f7',
    600: '#6418db',
    700: '#460e9e',
    800: '#300770',
    900: '#1d0349',
  },
  purple: {
    50: '#f9f1fe',
    100: '#eed8fd',
    200: '#e1b6fc',
    300: '#d38bfb',
    400: '#c85bf9',
    500: '#ae27e0',
    600: '#8514ac',
    700: '#60077e',
    800: '#44005a',
    900: '#2a003a',
  },
  pink: {
    50: '#FEF1F4',
    100: '#FDD6E1',
    200: '#FCB2C7',
    300: '#F984AA',
    400: '#F25090',
    500: '#CD2A74',
    600: '#9D1658',
    700: '#700C42',
    800: '#4E052B',
    900: '#32011A',
  },
}
